// SLT "view as teacher" session context. While set, api.js attaches the
// X-SLT-View-As header so GET requests return the teacher's data (the backend
// rejects all non-GET requests in this mode, keeping it strictly read-only).
import { auth } from '../firebase';

const storageKey = () => `sltViewAs_${auth.currentUser?.uid || 'anon'}`;

export const getSltViewAs = () => {
  try {
    return JSON.parse(sessionStorage.getItem(storageKey()) || 'null');
  } catch (err) {
    return null;
  }
};

export const setSltViewAs = ({ teacherUid, teacherName }) => {
  sessionStorage.setItem(storageKey(), JSON.stringify({ teacherUid, teacherName }));
};

export const clearSltViewAs = () => {
  sessionStorage.removeItem(storageKey());
};
